import {
  Box,
  BoxProps,
  ColorOptions,
  EmptyView,
  Icon,
  Loader,
  ModalDialog,
  ModBox,
  SearchBar,
  Spacer,
  Text,
} from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { isEmptyString } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { controlsData, getCustomColumnWidth } from '../../utils/constants'

const EssControlUpdate = () => {
  const [mid, setMid] = useState('')
  const [searchText, setSearchText] = useState('')
  const [addMidVidible, setAddMidVisible] = useState(false)

  const { fetchAllMids, addMids, ctpmFlag, getAllMids, fetchMidDetails, accessConfig, config } = useStores((store) => ({
    fetchAllMids: store.essControls.fetchAllMids,
    addMids: store.essControls.addMids,
    ctpmFlag: store.essControls.ctpmFlag,
    getAllMids: store.essControls.getAllMids,
    config: store.user.accessConfig,
    accessConfig: store.user.getAccessConfig(['ess', 'ess_control_update']),
    fetchMidDetails: store.searchMid,
  }))

  const [controlType, setControlType] = useState('')
  const [lazyFetchAllMids, { state, data: midApiDdata }] = useLazyApiData(fetchAllMids)
  const [lazyAddMids, { state: addApiState }] = useLazyApiData(addMids)
  const [lazyFetchSearchMidApi, { state: searchMidState }] = useLazyApiData(fetchMidDetails)

  const [data, setData] = useState([])
  const [searchData, setSearchData] = useState([])
  const isFetchAccessible = isAccessible(accessConfig, 'fetch')

  const mids = data?.map((item) => item.id)
  useEffect(() => {
    if (searchMidState === 'fulfilled' || searchMidState === 'rejected') {
      if (searchMidState === 'fulfilled') {
        data?.push({ id: mid, actionDownload: ',DELETE' })
        setData(data)
      }
      setMid('')
      setAddMidVisible(false)
      setSearchText('')
    }
  }, [searchMidState])
  useEffect(() => {
    isFetchAccessible && lazyFetchAllMids()
  }, [config])

  useEffect(() => {
    addApiState === 'fulfilled' && isFetchAccessible && lazyFetchAllMids()
  }, [addApiState])

  useEffect(() => {
    if (state === 'fulfilled') {
      setControlType(midApiDdata?.settlementFlag)
      const allData = getAllMids(midApiDdata?.settlementFlag)
      setSearchText('')
      setData(allData)
    }
  }, [state])
  const handleDelete = (mid: string) => {
    const allData = data?.filter((item) => {
      return item?.id !== mid
    })
    setSearchText('')
    setData(allData)
  }

  const onSearchChange = (val: string) => {
    setSearchText(val)
    const filterdData = data?.filter((item: any) => item.id.includes(val))
    setSearchData(filterdData)
  }

  const handleAddMids = () => {
    const isMidAdded = data?.find((item) => item.id === mid)

    if (!isMidAdded) {
      lazyFetchSearchMidApi(mid, 'Entity ID', 'checkEntityPresence')
    }
  }
  const onMidChange = (val: string) => {
    const str = val?.replace(/[^0-9]/g, '') ?? ''
    setMid(str)
  }

  const onFlagChange = (val) => {
    setSearchText('')
    setControlType(val)
    const allData = getAllMids(val)
    setData(allData)
  }

  const onRetry = () => {
    isFetchAccessible && lazyFetchAllMids()
  }
  if (state === 'rejected' || state === 'pending') {
    return (
      <Box f={1} justify={'center'}>
        <EmptyView
          onRetry={onRetry}
          isLoading={state === 'pending'}
          loaderComponent={<Loader type="small" color="PRIMARY" />}
          emptyMessage={midApiDdata?.message ?? 'Error while processing'}
          error={midApiDdata?.message && { networkError: { data: { errors: [{ details: midApiDdata?.message }] } } }}
        />
      </Box>
    )
  }
  return (
    <Box {...styles.container}>
      <Text title={'ESS Controls Update'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={16} />
      <Box flexDirection={'row'} align={'flex-end'} justify={'space-between'}>
        <Dropdown
          data={controlsData}
          dataFieldToRead={'value'}
          minWidth={320}
          fullWidthContent={true}
          value={controlType || 'Controls'}
          selectedData={onFlagChange}
        />
        <Spacer direction="horizontal" size={16} />
        <ButtonNew
          title={'ADD'}
          onPress={() => setAddMidVisible(true)}
          height={38}
          width={80}
          borderRadius={4}
          hide={controlType === 'MAS_AND_ESS' || controlType === 'MAS_ONLY' || controlType === 'ESS_ONLY'}
        />
        <ModalDialog type="CenteredWrap" show={addMidVidible}>
          <Box
            align="center"
            justify="center"
            bg={'WHITE'}
            borderWidth={1}
            borderRadius={8}
            p={24}
            borderColor={'DISABLED_GREY'}>
            <Box onPress={() => setAddMidVisible(false)} underlayColor={'TRANSPARENT'} pb={16} alignSelf={'flex-end'}>
              <Icon id={'CLOSE'} color={'PRIMARY_GREY'} size={16} />
            </Box>
            <TextInputNew
              value={mid}
              onChange={onMidChange}
              placeholder={'Enter MID'}
              placeholderTextColor={'PRIMARY_GREY'}
              borderColor={'DISABLED_GREY'}
              borderRadius={24}
              fontSize={16}
              maxLength={15}
              padding={12}
            />
            <Spacer direction="vertical" size={16} />
            <ButtonNew
              title={'ADD'}
              onPress={handleAddMids}
              height={32}
              width={80}
              borderRadius={4}
              isLoading={searchMidState === 'pending'}
              disabled={mid?.length !== 15}
            />
          </Box>
        </ModalDialog>
      </Box>
      <Spacer direction="vertical" size={16} />
      <ModBox
        w={240}
        show={
          controlType !== 'MAS_AND_ESS' && controlType !== 'MAS_ONLY' && controlType !== 'ESS_ONLY' && data?.length > 0
        }>
        <SearchBar
          value={searchText}
          onChange={onSearchChange}
          fontFamily={'jiotype-medium'}
          placeholder={'Search MID'}
        />
      </ModBox>
      <Spacer direction="vertical" size={16} />
      <ModBox
        w={360}
        show={
          controlType !== 'MAS_AND_ESS' &&
          controlType !== 'MAS_ONLY' &&
          controlType !== 'ESS_ONLY' &&
          (isEmptyString(searchText) ? data?.length > 0 : searchData?.length > 0)
        }
        h={(data?.length + 1) * 48}>
        <NewTable
          data={isEmptyString(searchText) ? data : searchData}
          headerHeight={48}
          headerRowKeys={{ id: 'MIDs', actionDownload: 'Delete' }}
          rowHeight={48}
          onRowClick={() => {}}
          customWidthFunc={getCustomColumnWidth}
          onAction={(_, id) => handleDelete(id)}
          tableWidth={360}
        />
        {data?.length === 0 &&
          controlType !== 'MAS_AND_ESS' &&
          controlType !== 'MAS_ONLY' &&
          controlType !== 'ESS_ONLY' && (
            <Box
              align="center"
              justify="center"
              borderLeftWidth={1}
              borderBottomWidth={1}
              borderRightWidth={1}
              borderColor={'DISABLED_GREY'}
              p={16}>
              <Text title={'No Data found'} />
            </Box>
          )}
      </ModBox>
      <Spacer direction="vertical" size={64} />
      <ButtonNew
        hide={!isAccessible(accessConfig, 'update')}
        onPress={() => lazyAddMids(controlType, data)}
        title={'Update'}
        isLoading={addApiState === 'pending'}
        disabled={
          controlType === 'ESS_MID_SPECIFIC_AND_MAS_ONLY_PAYOUT' || controlType === 'ESS_MID_SPECIFIC'
            ? controlType === ctpmFlag
              ? JSON.stringify(mids) === JSON.stringify(midApiDdata?.mids)
              : data?.length === 0
            : false
        }
      />
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    p: 20,
    overflow: 'auto',
  } as BoxProps,
}
export default EssControlUpdate
